import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerTwelve from "../components/DashBoardLayerTwelve";
import DashBoardLayerTest from "../components/DashBoardLayerTest";

const HomePageTest = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Doctor's Revenue" />

        {/* DashBoardLayerEleven */}
        <DashBoardLayerTest />
      </MasterLayout>
    </>
  );
};

export default HomePageTest;
